import {AsyncPipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {MatProgressBar} from '@angular/material/progress-bar';

import {MatSnackBarRef} from '@angular/material/snack-bar';
import {ManagedComponent} from '@app/shared/managed.component';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';

import {UploadProgress, UploadService} from '../upload.service';

@Component({
    selector: 'frog-upload-dialog',
    templateUrl: './upload-dialog.component.html',
    styleUrls: ['./upload-dialog.component.scss'],
    imports: [MatProgressBar, AsyncPipe],
})
export class UploadDialogComponent extends ManagedComponent implements OnInit {
    public progress: number;
    public uploadProgress$: Observable<UploadProgress>;

    constructor(
        private uploadService: UploadService,
        private dialogRef: MatSnackBarRef<UploadDialogComponent>,
    ) {
        super();
    }

    ngOnInit(): void {
        this.uploadProgress$ = this.uploadService.progress$.pipe(
            tap((progress) => {
                if (progress === null) {
                    // Stream complete
                    this.dialogRef.dismiss();
                }
            }),
        );
    }
}
